import { actionTree } from "typed-vuex";
import { ActionContext } from "vuex";
import { Response } from "@wl/types/lib/responses";
import { StatsRes } from "@wl/types/lib/responses/admin/stats.res";
import { RootState } from "..";
import getters from "./getters";
import mutations from "./mutations";
import state, { AdminState } from "./state";

type Context = ActionContext<AdminState, RootState>;
type Check = Response<boolean>;
type Stats = Response<StatsRes>;

/**
 * Admin module actions.
 */
const actions = actionTree(
    { state, getters, mutations },
    {
        /**
         * Fetches all module data.
         *
         * @param {Context} _ Action context
         * @return {Promise<void>}
         */
        async fetch(_: Context): Promise<void> {
            const response = await this.$axios.get<Stats>("/admin/stats");
            if (!response.data.error) this.app.$accessor.admin.setStats(response.data.data);
        },

        /**
         * Checks whether the logged in user is really a admin.
         *
         * @param {Context} _
         * @return {Promise<boolean>} Flag, whether the logged in user is really a admin
         */
        async check(_: Context): Promise<boolean> {
            const response = await this.$axios.get<Check>("/admin/check");
            if (response.data.error) return false;

            const result = response.data.data !== undefined ? response.data.data : false;
            if (result) this.app.$accessor.admin.fetch();

            return result;
        },
    },
);

export default actions;
